import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

import {generatePath, paths} from 'src/utils/paths'
import {Button} from '../buttons'
import {SpacingWrapper} from '../layout'
import {H4, PSmall} from '../typography'

interface Props {
  inCheckout?: boolean
}

const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`

export default function EmptyCart({inCheckout}: Props): JSX.Element {
  return (
    <>
      <SpacingWrapper spacing={50}>
        <EmptyContainer>
          <H4 withGutter>
            {' '}
            {inCheckout ? 'Karfan þín er tóm' : 'Karfan er tóm'}
          </H4>
          {inCheckout && (
            <PSmall color="black60">
              Þú þarft að vera með vörur í körfu til þess að halda áfram með
              kaupferli.
            </PSmall>
          )}
          <PSmall withGutter color="black60">
            Bættu úr því með því að skoða vörur í vefversluninni okkar!
          </PSmall>
          <Link href={generatePath(paths.categories)} passHref>
            <Button>Fara í vefverslun</Button>
          </Link>
        </EmptyContainer>
      </SpacingWrapper>
    </>
  )
}
